import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	addFieldDisplayText: {
		id: 'jql-builder-basic-order-by-select.add-field-picker.add-field-display-text',
		defaultMessage: 'Select field',
		description:
			'text that appears as initially selected dropdown value when adding a new dropdown filter',
	},
});

export default messages;
